<template>
  <DsPageLayout :theme="theme">
    <!-- <template #cookie-bar>
        <PageCookieBar />
      </template> -->
    <template #header>
      <LayoutPageHeader
        v-if="navigationData"
        header-theme="light"
        :navigation-data="navigationData"
        :hide-search="false"
        logo-as-nuxt-link
      />
      <div
        id="portal-header"
        ref="headerPortal"
        class="header-portal"
        @change="handleHeaderPortalUpdate($event, headerPortal)"
      />
    </template>
    <template #content>
      <div
        :style="{ paddingTop: `${headerPortalHeight}px` }"
        class="ds-width-full"
      >
        <slot />
      </div>
    </template>
    <template #footer>
      <LayoutPageFooter
        v-if="footerNavigationData"
        :footer-data="footerNavigationData"
      />
    </template>
    <template #overlay>
      <div id="portal-overlay" />
    </template>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-once
      v-html="noscriptHtml"
    />
    <!-- eslint-enable vue/no-v-html -->
  </DsPageLayout>
</template>

<script setup>
/**
 * Default Layout
 * will be used on pages where there is no custom layout set
 */
import { DsPageLayout } from 'awds'

const headerPortal = ref()

const { handleHeaderPortalUpdate, headerPortalHeight, noscriptHtml } = useLayout()
const { theme } = useTheme()
const { localeGlobalContentData } = usePressAndMediaGlobalData()
const navigationData = computed(() => localeGlobalContentData.value?.globalNavigationData?.main)
const footerNavigationData = computed(() => localeGlobalContentData.value?.globalFooterData?.main)
</script>
